import { render, staticRenderFns } from "./technical-specifications.vue?vue&type=template&id=42684a4d&scoped=true"
import script from "./technical-specifications.vue?vue&type=script&lang=js"
export * from "./technical-specifications.vue?vue&type=script&lang=js"
import style0 from "./technical-specifications.vue?vue&type=style&index=0&id=42684a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42684a4d",
  null
  
)

export default component.exports